module.exports = __webpack_public_path__ + "img/Mask Group 2922@2x.c513f966.png";